import PortalClienteDBService from "./bases/PortalClienteDBService";

class ContatosPortalDbService extends PortalClienteDBService{
    async ObterContato(){
        return await this.get(`portaldb/contatos/ObterContato`)
    }
}

export default new ContatosPortalDbService();